import React from 'react';
import { CreditCard, Mail, PlayCircle, MessageCircle } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
export function HowItWorks() {
  const steps = [{
    icon: <CreditCard className="w-6 h-6 text-rose" data-id="element-101" />,
    title: 'Pagás de forma segura',
    desc: 'Tarjeta, PayPal, transferencia — plataforma verificada'
  }, {
    icon: <Mail className="w-6 h-6 text-rose" data-id="element-102" />,
    title: 'Recibís el acceso por email',
    desc: 'En menos de 5 minutos, automático'
  }, {
    icon: <PlayCircle className="w-6 h-6 text-rose" data-id="element-103" />,
    title: 'Entrás a la plataforma',
    desc: 'Y empezás tu primera clase cuando quieras, a tu ritmo'
  }, {
    icon: <MessageCircle className="w-6 h-6 text-rose" data-id="element-104" />,
    title: 'Consultás tus dudas',
    desc: 'Soporte directo para resolver cualquier consulta'
  }];
  return <SectionWrapper bg="white" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-dark mb-16" data-id="element-107">
          ¿Cómo funciona?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative" data-id="element-108">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-blush -z-10" data-id="element-109"></div>

          {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center relative" data-id="element-110">
              <div className="w-16 h-16 rounded-full bg-white border-4 border-blush shadow-sm flex items-center justify-center mb-6 relative z-10" data-id="element-111">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-rose text-white text-xs font-bold rounded-full flex items-center justify-center border-2 border-white" data-id="element-112">
                  {idx + 1}
                </div>
              </div>
              <h3 className="font-bold text-lg text-warm-dark mb-2" data-id="element-113">
                {step.title}
              </h3>
              <p className="text-sm text-warm-muted" data-id="element-114">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}